if (!customElements.get('ah-service-cards')) {
  customElements.define('ah-service-cards', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.track = this.querySelector('.ah-pdp-experience__track');
      this.cards = Array.from(this.querySelectorAll('.ah-pdp-service'));
      this.previous = this.querySelector('[data-ah-prev]');
      this.next = this.querySelector('[data-ah-next]');
      this.dots = Array.from(this.querySelectorAll('[data-ah-slide]'));
      if (!this.track) return;
      this.querySelector('[data-ah-prev]')?.addEventListener('click', () => this.go(-1), {signal});
      this.querySelector('[data-ah-next]')?.addEventListener('click', () => this.go(1), {signal});
      this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.jump(index), {signal}));
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        if (event.key === 'Home') this.jump(0);
        else if (event.key === 'End') this.jump(this.cards.length - 1);
        else this.go(event.key === 'ArrowRight' ? 1 : -1);
      }, {signal});
      this.track.addEventListener('scroll', () => this.update(), {signal, passive: true});
      this.observer = new ResizeObserver(() => this.update());
      this.observer.observe(this.track);
      this.update();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.controller = null;
    }
    current() {
      if (!this.cards.length) return 0;
      const left = this.track.getBoundingClientRect().left;
      let closest = 0;
      this.cards.forEach((card, i) => {
        if (Math.abs(card.getBoundingClientRect().left - left) < Math.abs(this.cards[closest].getBoundingClientRect().left - left)) closest = i;
      });
      return closest;
    }
    jump(index) {
      const card = this.cards[Math.max(0, Math.min(index, this.cards.length - 1))];
      if (!card) return;
      const offset = card.getBoundingClientRect().left - this.track.getBoundingClientRect().left + this.track.scrollLeft;
      this.track.scrollTo({left: offset, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
    }
    go(step) { this.jump(this.current() + step); }
    update() {
      const canScroll = this.cards.length > 1 && this.track.scrollWidth > this.track.clientWidth + 2;
      this.querySelector('.ah-pdp-experience__arrows').hidden = !canScroll;
      this.querySelector('.ah-pdp-experience__dots').hidden = !canScroll;
      this.previous.disabled = !canScroll || this.track.scrollLeft <= 2;
      this.next.disabled = !canScroll || this.track.scrollLeft >= this.track.scrollWidth - this.track.clientWidth - 2;
      const current = this.current();
      this.dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === current)));
    }
  });
}
